import supabaseClient from '@/api/supabaseClient';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { queryClient } from '@/main.tsx';

const useStartTrial = () => {
  const client = supabaseClient;

  return useMutation({
    mutationFn: () => startTrial(client),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['userFeatures'] });
      void queryClient.invalidateQueries({ queryKey: ['user'] });
      void queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    },
  });
};

export default useStartTrial;

async function startTrial(client: SupabaseClient): Promise<void> {
  const { error } = await client.functions.invoke('start_trial');

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }
}
